/**
 * Generate error config by server error.
 * @param {Object} errors server errors.
 * @param {Object} [error.1011] no bets available.
 * @return {String} client bet error message.
 */
export default function getErrorText(errors) {
    const errorCodes = Object.keys(errors);
    const errorCode = errorCodes.pop();
    if (errorCode === '404') {
        return 'No bets found.';
    }
    return 'We have experienced an error and could not retrieve your bet history.' +
        ' Please try again later.';
}



// WEBPACK FOOTER //
// /src/js/bookmakersSwitcher/accountPage/components/betHistory/components/getErrorText.js